module.exports = __webpack_public_path__ + "static/media/add_service.1e1fc9a5.svg";